import { render, staticRenderFns } from "./RemoveNotification.vue?vue&type=template&id=052ecb82&scoped=true&"
import script from "./RemoveNotification.vue?vue&type=script&lang=js&"
export * from "./RemoveNotification.vue?vue&type=script&lang=js&"
import style0 from "./RemoveNotification.vue?vue&type=style&index=0&id=052ecb82&scoped=true&lang=css&"
import style1 from "./RemoveNotification.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052ecb82",
  null
  
)

export default component.exports